<template>
    <div>
        <div v-if="records.length > 0">
            <div v-if="enableFilter">
                <record-filter-bar :id="id"
                                   :records="this.records"
                                   :record-fields-to-filter="this.recordFieldsToDisplay">
                </record-filter-bar>
            </div>

            <div v-if="filteredRecords.length > 0">
            	<table class="table table-striped table-bordered table-sm">
            		<thead>
            			<tr class="thead-dark">
                            <th v-if="isAttachViewMode" class="text-center">
                                <i class="fa fa-plus-circle" :title="'Attach ' + recordType"></i>
                            </th>

                            <th v-if="isDetachViewMode" class="text-center">
                                <i class="fa fa-minus-circle" :title="'Detach ' + recordType"></i>
                            </th>

                            <th v-if="showAttachedRecordLink" class="text-center cell-sm">
                                <i class="fa fa-eye" :title="'View ' + recordType"></i>                            
                            </th>

                            <th v-for="(fieldName, index) in recordFieldsToDisplay" :key="index">
                                {{ translate('RecordManager.' + recordType + '.' + fieldName) }}
                            </th>
            			</tr>
            		</thead>
            		<tbody>
            			<tr v-for="(record, index) in filteredRecords" :key="index">
                            <td v-if="isAttachViewMode" class="text-center cell-sm">
                                <div v-if="showCreateForm">
                                    <add-record-button :redirect-url="createRecordFormUri(record.id)">
                                        <i class="fa fa-plus-circle"></i>
                                    </add-record-button>
                                </div>
                                <div v-else>
                                    <add-record-button :endpoint="attachRecordUri(record.id)" :redirect-url="redirectUri">
                                        <i class="fa fa-plus-circle"></i>
                                    </add-record-button>
                                </div>
                            </td>

                            <td v-if="isDetachViewMode" class="text-center cell-sm">
                                <delete-record-button :endpoint="detachRecordUri(record.id)" :redirect-url="redirectUri">
                                    <i class="fa fa-minus-circle"></i>
                                </delete-record-button>
                            </td>

                            <td v-if="showAttachedRecordLink" class="text-center cell-sm">
                                <a :href="record.attached_record_link" class="btn btn-secondary btn-sm" :title="'View ' + recordType">
                                    <i class="fa fa-eye"></i>
                                </a>
                            </td>

                            <td v-for="(fieldName, index) in recordFieldsToDisplay" :key="index"
                                v-html="translate('RecordManager.' + recordType + '.' + record[fieldName]) !== recordType + '.' + record[fieldName] ? translate('RecordManager.' + recordType + '.' + record[fieldName]) : record[fieldName]">
                            </td>
            			</tr>
            		</tbody>
            	</table>
            </div>
            <p v-else>
                No records matched your filter text: <strong>{{ this.filterQuery }}</strong>
            </p>
        </div>
        <p v-else-if="isAttachViewMode">
            No {{ recordType | pluralize(recordType) | injectWhitespace | capitalizeWords }} are available to attach.
        </p>
        <p v-else-if="isDetachViewMode">
            No {{ recordType | pluralize(recordType) | injectWhitespace | capitalizeWords }} have been attached.
        </p>
    </div>
</template>

<script>
    export default {
        props: {
            records: { type: Array, required: true },
            recordType: { type: String, required: true },
            resourceUriPrefix: { type: String, required: true },
            redirectUri: { type: String, required: true },
            recordFieldsToDisplay: { type: Array, required: false },
            showAttachedRecordLink: { type: Boolean, required: false, default: false },
            showCreateForm: { type: Boolean, required: false, default: false },
            viewMode: { type: String, required: false },
            enableFilter: { type: Boolean, required: false, default: true }
        },

        data() {
            return {
                id: this._uid,
                filterQuery: '',
                filteredRecords: this.records
            }
        },

        created() {
            EventDispatcher.listen('filterRecordsByFilterQuery' + this.id, (payload) => {
                this.filterQuery = payload.filterQuery;
                this.filteredRecords = payload.filteredRecords;
            });
        },

        computed: {
            isAttachViewMode() {
                return this.viewMode == 'ATTACH_RECORD_VIEW_MODE';
            },

            isDetachViewMode() {
                return this.viewMode == 'DETACH_RECORD_VIEW_MODE';
            }
        },

        methods: {
            createRecordFormUri(recordId) {
                return this.resourceUriPrefix + '/' + recordId + '/create';
            },

            attachRecordUri(recordId) {
                return this.resourceUriPrefix + '/' + recordId;
            },

            detachRecordUri(recordId) {
                return this.resourceUriPrefix + '/' + recordId;
            }
        }
    }
</script>

<style lang="scss">
    .table-bordered {
        thead th {
            white-space: nowrap !important;
        }

        td {
            border: 1px solid #fff;
        }
    }

    .cell-sm {
        width: 5%;
    }
</style>